// Central analytics loader — respects user cookie consent and only fires when the
// corresponding env-var ID is present. Safe to call any tracking function anywhere;
// if IDs are missing or consent hasn't been granted, the calls are no-ops.

const IDS = {
  metaPixel: process.env.REACT_APP_META_PIXEL_ID || "",
  ga4: process.env.REACT_APP_GA4_ID || "",
  googleAds: process.env.REACT_APP_GOOGLE_ADS_ID || "",
  googleAdsLabel: process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || "",
  linkedin: process.env.REACT_APP_LINKEDIN_PARTNER_ID || "",
};

let initialized = false;

const injectScript = (src, id, async = true) => {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.async = async;
  s.src = src;
  s.id = id;
  document.head.appendChild(s);
};

const injectInline = (id, code) => {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.text = code;
  document.head.appendChild(s);
};

export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;

  // Meta Pixel
  if (IDS.metaPixel) {
    injectInline(
      "meta-pixel-init",
      `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${IDS.metaPixel}');
      fbq('track', 'PageView');`
    );
    // noscript fallback img
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${IDS.metaPixel}&ev=PageView&noscript=1"/>`;
    document.head.appendChild(noscript);
  }

  // GA4 + Google Ads (both use gtag.js) — base tag ships in index.html with Consent
  // Mode v2 defaults denied; here (after user consent) we upgrade consent to granted.
  const gtagId = IDS.ga4 || IDS.googleAds;
  if (gtagId) {
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${gtagId}`, "gtag-src");
    injectInline(
      "gtag-init",
      `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      ${IDS.ga4 ? `gtag('config', '${IDS.ga4}');` : ""}
      ${IDS.googleAds ? `gtag('config', '${IDS.googleAds}');` : ""}`
    );
    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      });
    }
  }

  // LinkedIn Insight Tag
  if (IDS.linkedin) {
    injectInline(
      "linkedin-init",
      `_linkedin_partner_id = "${IDS.linkedin}";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);`
    );
    injectInline(
      "linkedin-tag",
      `(function(l) {
      if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
      window.lintrk.q=[]}
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);})(window.lintrk);`
    );
  }
};

// ---------- Event helpers ----------
export const trackPageView = (path) => {
  if (window.fbq) window.fbq("track", "PageView");
  if (window.gtag && IDS.ga4) window.gtag("event", "page_view", { page_path: path });
};

export const trackLead = (details = {}) => {
  // Meta Pixel — Lead
  if (window.fbq) window.fbq("track", "Lead", details);
  // GA4 — generate_lead
  if (window.gtag) window.gtag("event", "generate_lead", { currency: "INR", value: 5000, ...details });
  // Google Ads conversion
  if (window.gtag && IDS.googleAds && IDS.googleAdsLabel) {
    window.gtag("event", "conversion", {
      send_to: `${IDS.googleAds}/${IDS.googleAdsLabel}`,
    });
  }
  // LinkedIn — general conversion (user configures conversion ID in campaign manager)
  if (window.lintrk) window.lintrk("track");
};

export const trackContact = (channel = "whatsapp") => {
  if (window.fbq) window.fbq("track", "Contact", { channel });
  if (window.gtag) window.gtag("event", "contact", { channel });
};

export const trackCustom = (name, params = {}) => {
  if (window.fbq) window.fbq("trackCustom", name, params);
  if (window.gtag) window.gtag("event", name, params);
};
